import { HelmetDexteel } from "@dexteel/mesf-core";
import { Box } from "@mui/material";

import { HeatAgeThresholdsForm } from "./components/HeatAgeThresholdsForm";

export const HeatAgeThresholdsPage = () => (
	<>
		<HelmetDexteel title="Heat Age Thresholds" />
		<Box sx={{ p: 2 }}>
			<HeatAgeThresholdsForm />
		</Box>
	</>
);
